export default "__VITE_ASSET__BYqyiOfK__"